import { PermissionCheckerService } from 'abp-ng2-module';
import { Component, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AppSessionService } from '@shared/common/session/app-session.service';
import { AppUiCustomizationService } from '@shared/common/ui/app-ui-customization.service';
import { AppMenu } from './app-menu';
import { AppNavigationService } from './app-navigation.service';
import { GetCurrentLoginInformationsOutput, ProjectOutput, CalculationOutput, SessionServiceProxy, CalculationInput, UserLoginInfoDto, SubscriptionServiceProxy } from '@shared/service-proxies/service-proxies';
import { CalculationService, PlanService, ProductService, SettingService } from 'services/project.service';
import { Observable, Observer, Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { saveAs } from 'file-saver';
import * as moment from 'moment';
import { LoaderService } from '@app/main/cablepro/loader.service';
import { CompanyAccountService } from '@shared/service-proxies/company-account.service';
import { MomentHelper } from '@shared/helpers/MomentHelper';
import { CalcVersionUpdateComponent } from '@app/main/cablepro/calc-version-update/calc-version-update.component';
import { PdfReportServiceProxy } from '@shared/service-proxies/service-proxy-rpt';
import { CABLE_SIZING_STANDARDS, standardNameLabel, standardNameRegion } from '@shared/utils/cable-sizing-standards';

@Component({
    templateUrl: './side-bar-menu.component.html',
    styleUrls: ['./side-bar-menu.component.scss'],
    selector: 'side-bar-menu',
    encapsulation: ViewEncapsulation.None
})
export class SideBarMenuComponent extends AppComponentBase implements OnInit {

    menu: AppMenu = new AppMenu('', '', []);
    public isAdminUser: boolean = false;
    headerlabel: string;
    mode: string;
    recentProjects$: Observable<ProjectOutput[]>;
    recentCalculations$: Observable<CalculationOutput[]>;
    // Read live from the session so the sidebar follows changes to the preferred standard.
    get calculationStandard(): number {
        return this._appSessionService.user?.userSetting?.standards_CableSizing || 0;
    }
    public projectName: string = '';

    public isPlanAddedManually: boolean = false;
    public hasPlanExpired: boolean = false;
    public planExtendedCount: number = 0;
    public expiredPlanHeadingText: string = '';
    public expiredPlanBodyText: string = '';
    public CalculationReportInput: any;
    public isLoaderForExtendPlan = false;
    public isCreatingCalculation = false;
    public isCableSizingExpanded = false;
    public readonly cableSizingStandards = CABLE_SIZING_STANDARDS;
    // public isPaymentNotRecieved: boolean = false;
    private planDueDays: number = 0;
    public unRegisteredUser: boolean = false;
    private userStripeCustomerId: string = '';
    public premiumUser!: boolean;
    public user: UserLoginInfoDto;
    public isPlanLevelOne: boolean = false;
    public isPlanLevelTwo: boolean = false;
    public isPlanLevelThree: boolean = false;
    constructor(
        injector: Injector,
        private _router: Router,
        public permission: PermissionCheckerService,
        private _pdfReportSerivceProxy: PdfReportServiceProxy,
        private _appSessionService: AppSessionService,
        private _uiCustomizationService: AppUiCustomizationService,
        private _appNavigationService: AppNavigationService,
        private _sessionService: SessionServiceProxy,
        private _productService: ProductService,
        private _calculationService: CalculationService,
        private activeRoute: ActivatedRoute,
        private _settingService: SettingService,
        private _planService: PlanService,
        private loaderService: LoaderService,
        private _companyAccountService: CompanyAccountService,
        private _subscriptionService: SubscriptionServiceProxy,
    ) {
        super(injector);
        (window as any).sidebar = this;
    }

    ngOnInit() {
        this.menu = this._appNavigationService.getMenu();
        //this._settingService.getSettings().subscribe((result) => {
        //});
        this.CalculationReportInput = {};

        this.user = this._appSessionService.user;
        this.isAdminUser = (this._appSessionService.role.roleId === 1 || this._appSessionService.role.roleId === 2);
        this.isPlanAddedManually = this.user.isPlanAddedManually;
        this.premiumUser = this.user.premiumUser;
        this.unRegisteredUser = false;
        this.userStripeCustomerId = this.user.userStripeCustomerId;
        this.planExtendedCount = this.user.trialPeriodExtendedCount;
        if (this.user.periodEndDate != null && this.user.periodEndDate != undefined
            && this.user.periodEndDate == "Inactive") {
            this.expiredPlanHeadingText = 'Your Plan has Expired';
            this.expiredPlanBodyText = 'We have great value monthly and annual plans';
            this.hasPlanExpired = true;
        }
        else {
            if (this.user.periodEndDate != null && this.user.periodEndDate != undefined
                && this.user.periodEndDate != "succeeded") {
            }
        }
        if (this._appSessionService.user.userStripePlanLevel !== null && this._appSessionService.user.userStripePlanLevel !== undefined) {
            if (this._appSessionService.user.userStripePlanLevel == 1) {
                this.isPlanLevelOne = true;
            }
            else if (this._appSessionService.user.userStripePlanLevel == 2) {
                this.isPlanLevelTwo = true;
            }
            else if (this._appSessionService.user.userStripePlanLevel == 3) {
                this.isPlanLevelThree = true;
            }
        }
        if (this.userStripeCustomerId === null || this.userStripeCustomerId === undefined) {
            this.unRegisteredUser = true;
        }
        else if (this.userStripeCustomerId.trim().length == 0 || this.userStripeCustomerId.trim() == '0') {
            this.unRegisteredUser = true;
        }


        let _hasPlanExpired = this.premiumUser && MomentHelper.IsSubscriptionDateExpired(this.user.expirationDate);
        let _planDueDays = MomentHelper.GetSubscriptionDueDays(this.user.expirationDate);
        this.planDueDays = _planDueDays;
        this.hasPlanExpired = _hasPlanExpired;
        if (this.user.periodEndDate != null && this.user.periodEndDate != undefined
            && this.user.periodEndDate == "Inactive") {
            this.hasPlanExpired = true;
        }

        if (!this.isAdminUser) {
            if ((_hasPlanExpired || (_planDueDays >= -7 && _planDueDays <= 0))) {
                this.hasPlanExpired = _hasPlanExpired;
                this.planDueDays = _planDueDays;
            }
        }

        this._productService.refreshSidebarProjects();
        this._calculationService.refreshSidebarCalculations();

        this._productService.recentProjects.subscribe(projects => {
            if (projects)
                this.recentProjects$ = projects;
        });

        this._calculationService.recentCalculations.subscribe(calculations => {
            this.recentCalculations$ = calculations;
        });
    }

    GetDate(str: any) {

        var arr = str.split('/');
        var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        var i = 0;
        for (i; i < months.length; i++) {
            if (months[i] == arr[1]) {
                break;
            }
        }
        var formatddate = (i + 1) + '/' + arr[0] + '/' + arr[2];
        return formatddate;
    }

    showMenuItem(menuItem): boolean {
        // if (this.isAdminUser) {
        if (menuItem.permissionName === 'Pages.Administration.Tenant.SubscriptionManagement' && this._appSessionService.tenant && !this._appSessionService.tenant.edition) {
            return false;
        }
        // }

        if (menuItem.permissionName) {
            return this.permission.isGranted(menuItem.permissionName);
        }

        if (menuItem.items && menuItem.items.length) {
            // if (this.isAdminUser) {
            return this._appNavigationService.checkChildMenuItemPermission(menuItem);
            // }
            // else {
            //     return this._appNavigationService.checkChildMenuItemPermission(menuItem);
            // }
        }

        return true;
    }

    get defaultCableSizingStandard() {
        return this.cableSizingStandards.find(s => s.code === this.calculationStandard) || this.cableSizingStandards[0];
    }

    get otherCableSizingStandards() {
        const defaultCode = this.defaultCableSizingStandard.code;
        return this.cableSizingStandards.filter(s => s.code !== defaultCode);
    }

    toggleCableSizingExpand(event: Event): void {
        event.stopPropagation();
        event.preventDefault();
        this.isCableSizingExpanded = !this.isCableSizingExpanded;
    }

    standardNameLabel(name: string): string {
        return standardNameLabel(name);
    }

    standardNameRegion(name: string): string {
        return standardNameRegion(name);
    }

    addCableSizingCalculationForStandard(calculationType: number): void {
        if (!this.canCreateCalculation()) {
            return;
        }
        let calculationInput: CalculationInput = new CalculationInput();
        calculationInput.calculationType = calculationType;
        calculationInput.projectId = 0;
        let params = this.collectRouteParams(this.activeRoute);

        if (params && params["pid"]) {
            calculationInput.projectId = parseInt(params["pid"]);
        }
        this.createCalculation(calculationInput);
    }

    private canCreateCalculation(): boolean {
        if (this.isCreatingCalculation) {
            return false;
        }
        if (this.unRegisteredUser && (this.hasPlanExpired || (this.planDueDays >= -7 && this.planDueDays <= 0))) {
            if (this.premiumUser && this.hasPlanExpired) {
                this.handleUnlicencesOrExpiredFlow(this.user, this.calculationStandard, this._companyAccountService, this._router);
                return false;
            }
            // else {
            //     this.setExpirePlanDetails();
            //     return;
            // }
        }
        if (this.user?.periodEndDate != null && this.user?.periodEndDate != undefined
            && this.user?.periodEndDate == "Inactive") {
            this.handleUnlicencesOrExpiredFlow(this.user, this.calculationStandard, this._companyAccountService, this._router);
            return false;
        }
        else {
            if (this.user?.periodEndDate != null && this.user?.periodEndDate != undefined
                && this.user?.periodEndDate != "succeeded") {
                this.handleFailedOrUnpaidFlow(this.user, this.loaderService, this._subscriptionService, this._companyAccountService, this._router);
                return false;
            }
        }
        return true;
    }

    addNewCalculation(calculationType: number) {
        if (!this.canCreateCalculation()) {
            return;
        }
        let calculationInput: CalculationInput = new CalculationInput();
        if (calculationType == 1 && this.calculationStandard == 1) {
            calculationInput.calculationType = 13;
        }
        else if (calculationType == 1 && this.calculationStandard == 2) {
            calculationInput.calculationType = 3;
        }
        else if (calculationType == 1 && this.calculationStandard == 3) {
            calculationInput.calculationType = 9;
        }
        else if (calculationType == 1 && this.calculationStandard == 4) {
            calculationInput.calculationType = 12;
        }
        else {
            calculationInput.calculationType = calculationType;
        }
        calculationInput.projectId = 0;
        let params = this.collectRouteParams(this.activeRoute);

        if (params && params["pid"]) {
            calculationInput.projectId = parseInt(params["pid"]);
        }
        this.createCalculation(calculationInput);
    }

    createCalculation(calculationInput: CalculationInput) {
        this.isCreatingCalculation = true;
        this._calculationService.createCalculation(calculationInput)
            .pipe(finalize(() => { this.isCreatingCalculation = false; }))
            .subscribe(result => {
                if (result && result.success === false) {
                    this._appSessionService.UsageLimitReached("Storage Limit Reached", result.message, result.isProfessional);
                    return;
                }
                else {
                    var returnUrl = '';
                    if (calculationInput.calculationType === 1) {
                        returnUrl = '?returnUrl=/app/main/projects/' + result.projectId + '/au-calcs/' + result.id;
                    }
                    else if (calculationInput.calculationType === 3) {
                        returnUrl = '?returnUrl=/app/main/projects/' + result.projectId + '/bscalcs/' + result.id;
                    }
                    else if (calculationInput.calculationType === 4) {
                        returnUrl = '?returnUrl=/app/main/projects/' + result.projectId + '/automaxd/' + result.id;
                    }
                    else if (calculationInput.calculationType === 5) {
                        returnUrl = '?returnUrl=/app/main/projects/' + result.projectId + '/pdccalcs/' + result.id;
                    }
                    else if (calculationInput.calculationType === 6) {
                        returnUrl = '?returnUrl=/app/main/projects/' + result.projectId + '/calcp/' + result.id;
                    }
                    else if (calculationInput.calculationType === 7) {
                        returnUrl = '?returnUrl=/app/main/projects/' + result.projectId + '/networkcalc/' + result.id;
                    }
                    else if (calculationInput.calculationType === 8) {
                        returnUrl = '?returnUrl=/app/main/projects/' + result.projectId + '/arcflash/' + result.id;
                    }
                    else if (calculationInput.calculationType === 9) {
                        returnUrl = '?returnUrl=/app/main/projects/' + result.projectId + '/iec-calcs/' + result.id;
                    }
                    else if (calculationInput.calculationType === 12) {
                        returnUrl = '?returnUrl=/app/main/projects/' + result.projectId + '/nec-calcs/' + result.id;
                    }
                    else if (calculationInput.calculationType === 13) {
                        returnUrl = '?returnUrl=/app/main/projects/' + result.projectId + '/nz-calcs/' + result.id;
                    }
                    else {
                        return;
                    }
                    // do not append version as it is being appended from routeback component.
                    this._router.navigateByUrl('/app/main/routeback' + returnUrl);
                    this._calculationService.refreshSidebarCalculations();
                    this._productService.refreshSidebarProjects();
                }
            });
    }

    SetCalculationLink(calculation): any {
        let calculationType: string = 'au-calcs';

        if (calculation.calculationType === 2)
            calculationType = 'maxd';
        else if (calculation.calculationType === 3)
            calculationType = 'bscalcs';
        else if (calculation.calculationType === 4)
            calculationType = 'automaxd';
        else if (calculation.calculationType === 5)
            calculationType = 'pdccalcs';
        else if (calculation.calculationType === 6)
            calculationType = 'calcp';
        else if (calculation.calculationType === 7)
            calculationType = 'networkcalc';
        else if (calculation.calculationType === 8)
            calculationType = 'arcflash';
        else if (calculation.calculationType === 9)
            calculationType = 'iec-calcs';
        else if (calculation.calculationType === 12)
            calculationType = 'nec-calcs';
        else if (calculation.calculationType === 13)
            calculationType = 'nz-calcs';
        return ['/app/main/projects/' + calculation.projectId + '/' + calculationType + '/' + calculation.id];
    }

    OpenCalculation(calculation): any {
        if (this.unRegisteredUser && (this.hasPlanExpired || (this.planDueDays >= -7 && this.planDueDays <= 0))) {
            if (this.premiumUser && this.hasPlanExpired) {
                this.handleUnlicencesOrExpiredFlow(this.user, this.calculationStandard, this._companyAccountService, this._router);
                return
            }
            // else {
            //     this.setExpirePlanDetails();
            //     return;
            // }
        }

        if (this.user?.periodEndDate != null && this.user?.periodEndDate != undefined
            && this.user?.periodEndDate == "Inactive") {
            this.handleUnlicencesOrExpiredFlow(this.user, this.calculationStandard, this._companyAccountService, this._router);
            return;
        }
        else {
            if (this.user?.periodEndDate != null && this.user?.periodEndDate != undefined
                && this.user?.periodEndDate != "succeeded") {
                this.handleFailedOrUnpaidFlow(this.user, this.loaderService, this._subscriptionService, this._companyAccountService, this._router);
                return;
            }
        }

        if (calculation.latestXmlVersion > calculation.calculationXmlVersion) {

            const modalRef = this.ngbModalService.open(CalcVersionUpdateComponent);
            modalRef.componentInstance.isReportAvailable = calculation.isReportAvailable;
            modalRef.componentInstance.calculationid = calculation.id;
            let calculationType: string = 'CableSizeAUS';
            modalRef.componentInstance.reportAttachmentName = 'Cable_Sizing_Report_';

            if (calculation.calculationType === 3) {
                calculationType = 'CableSizeBS';
            }
            else if (calculation.calculationType === 13) {
                calculationType = 'CableSizeNZS';
                modalRef.componentInstance.reportAttachmentName = 'CableSizeNZ_Report_';

            }
            else if (calculation.calculationType === 4) {
                calculationType = 'AutoMaxDemand';
                modalRef.componentInstance.reportAttachmentName = 'Maximum_Demand_Report_';

            }
            else if (calculation.calculationType === 5) {
                calculationType = 'ProtectiveCoordination';
                modalRef.componentInstance.reportAttachmentName = 'Protection_Coordination_Report_';

            }
            else if (calculation.calculationType === 6) {
                calculationType = 'CablePulling';
                modalRef.componentInstance.reportAttachmentName = 'Cable_Pulling_Report_';

            }
            else if (calculation.calculationType === 7) {
                calculationType = 'NetworkCalculation';
                modalRef.componentInstance.reportAttachmentName = 'Network_Calculation_Report_';

            }
            else if (calculation.calculationType === 8) {
                calculationType = 'ArcFlash';
                modalRef.componentInstance.reportAttachmentName = 'ArcFlash_Report_';

            }
            else if (calculation.calculationType === 9) {
                calculationType = 'CableSizeIEC';
                modalRef.componentInstance.reportAttachmentName = 'CableSizeIEC_Report_';

            }
            else if (calculation.calculationType === 12) {
                calculationType = 'CableSizeNEC';
                modalRef.componentInstance.reportAttachmentName = 'CableSizeNEC_Report_';

            }
            if (calculation.isReportAvailable == true)
                this.DownloadReport(calculationType, calculation.id);
            this.projectName = calculation.projectName;
            modalRef.componentInstance.calculationType = calculationType;
            modalRef.componentInstance.projectId = calculation.projectId;
            modalRef.componentInstance.calculationName = calculation.name;
            modalRef.componentInstance.projectName = calculation.projectName;
            modalRef.componentInstance.reportAttachmentName += calculation.projectName + '_';
            modalRef.componentInstance.reportAttachmentName += calculation.name + '.pdf';
            this.CalculationReportInput.reportAttachmentName = modalRef.componentInstance.reportAttachmentName;
            modalRef.result.then((result: string) => {
                if (result == 'download') {

                }
                if (result == 'upgrade') {
                    // modalRef.componentInstance.xmlloader = true;
                    //this.updateXmlVersion(calculation);
                }
            }, (reason) => {
                if (reason == true) {
                    this.projectName = calculation.projectName;
                    this.SetCalculationLink(calculation);

                }

            });
            //              }
        }
        else {
            var returnUrl = '';

            if (calculation.calculationType === 1) {
                returnUrl = '?returnUrl=/app/main/projects/' + calculation.projectId + '/au-calcs/' + calculation.id;
            }
            else if (calculation.calculationType === 3) {
                returnUrl = '?returnUrl=/app/main/projects/' + calculation.projectId + '/bscalcs/' + calculation.id;
            }
            else if (calculation.calculationType === 4) {
                returnUrl = '?returnUrl=/app/main/projects/' + calculation.projectId + '/automaxd/' + calculation.id;
            }
            else if (calculation.calculationType === 5) {
                returnUrl = '?returnUrl=/app/main/projects/' + calculation.projectId + '/pdccalcs/' + calculation.id;
            }
            else if (calculation.calculationType === 6) {
                returnUrl = '?returnUrl=/app/main/projects/' + calculation.projectId + '/calcp/' + calculation.id;
            }
            else if (calculation.calculationType === 7) {
                returnUrl = '?returnUrl=/app/main/projects/' + calculation.projectId + '/networkcalc/' + calculation.id;
            }
            else if (calculation.calculationType === 8) {
                returnUrl = '?returnUrl=/app/main/projects/' + calculation.projectId + '/arcflash/' + calculation.id;
            }
            else if (calculation.calculationType === 9) {
                returnUrl = '?returnUrl=/app/main/projects/' + calculation.projectId + '/iec-calcs/' + calculation.id;
            }
            else if (calculation.calculationType === 12) {
                returnUrl = '?returnUrl=/app/main/projects/' + calculation.projectId + '/nec-calcs/' + calculation.id;
            }
            else if (calculation.calculationType === 13) {
                returnUrl = '?returnUrl=/app/main/projects/' + calculation.projectId + '/nz-calcs/' + calculation.id;
            }
            else {
                return;
            }
            // do not append version as it is being appended from routeback component.
            this._router.navigateByUrl('/app/main/routeback' + returnUrl);
        }
    }
    DownloadReport(calculation_type, calculationid): void {

        //this.CalculationReportInput.reportAttachmentName = this.reportAttachmentName;
        this.CalculationReportInput.calculationId = calculationid;
        this.CalculationReportInput.calculation_type = calculation_type;
        if (calculation_type == 'NetworkCalculation' || calculation_type == 'ArcFlash') {
            this._pdfReportSerivceProxy.DownloadZipOfReportFromS3(this.CalculationReportInput).subscribe((result) => {
                let blob = new Blob([result.body], { type: 'application/octet-stream' });
                saveAs(blob, this.CalculationReportInput.reportAttachmentName + ".zip");

            }, () => {

                this._modalPopupService.confirm("Developer error", "Error occured while downloading the report.<br><br>Please contact support for assistance.", (value) => {
                    if (value) {
                        $(".clsscreenshot").hide();
                        $("#contactusDlg").modal("show");
                    }
                }, undefined, "Contact Support", "btn-primary", "Close")
            }
            );
        }
        else {
            this._pdfReportSerivceProxy.GenerateReportFromS3(this.CalculationReportInput).subscribe((result) => {


                let blob = new Blob([result.body], { type: 'application/pdf' });
                saveAs(blob, this.CalculationReportInput.reportAttachmentName);




            }, () => {

                this._modalPopupService.confirm("Developer error", "Error occured while downloading the report.<br><br>Please contact support for assistance.", (value) => {
                    if (value) {
                        $(".clsscreenshot").hide();
                        $("#contactusDlg").modal("show");
                    }
                }, undefined, "Contact Support", "btn-primary", "Close");
                return;
            });
        }


    }

    OpenProject(project): any {
        if (this.unRegisteredUser && (this.hasPlanExpired || (this.planDueDays >= -7 && this.planDueDays <= 0))) {
            if (this.premiumUser && this.hasPlanExpired) {
                this.handleUnlicencesOrExpiredFlow(this.user, this.calculationStandard, this._companyAccountService, this._router);
                return
            }
            // else {
            //     this.setExpirePlanDetails();
            //     return;
            // }
        }
        if (this.user?.periodEndDate != null && this.user?.periodEndDate != undefined
            && this.user?.periodEndDate == "Inactive") {
            this.handleUnlicencesOrExpiredFlow(this.user, this.calculationStandard, this._companyAccountService, this._router);
            return;
        }
        else {
            if (this.user?.periodEndDate != null && this.user?.periodEndDate != undefined
                && this.user?.periodEndDate != "succeeded") {
                this.handleFailedOrUnpaidFlow(this.user, this.loaderService, this._subscriptionService, this._companyAccountService, this._router);
                return;
            }
        }
        var otherParams = '?v=' + this.appSession.application.version;
        this._router.navigateByUrl('/app/main/projects/' + project.id + '/calcs' + otherParams);
    }

    private collectRouteParams(route: ActivatedRoute): any {
        let currentRoute: ActivatedRoute | null = route;
        const params: any = {}; // Object to store parameters from all children

        while (currentRoute) {
            const currentParams = currentRoute.snapshot.params;
            Object.assign(params, currentParams);

            // Move to the next child route
            currentRoute = currentRoute.firstChild;
        }

        return params;
    }

    checkActiveClass(calculation): boolean {
        let result: boolean = false;
        var url = '';
        if (calculation.calculationType === 1) {
            url = '/app/main/projects/' + calculation.projectId + '/au-calcs/' + calculation.id;
        }
        else if (calculation.calculationType === 3) {
            url = '/app/main/projects/' + calculation.projectId + '/bscalcs/' + calculation.id;
        }
        else if (calculation.calculationType === 4) {
            url = '/app/main/projects/' + calculation.projectId + '/automaxd/' + calculation.id;
        }
        else if (calculation.calculationType === 5) {
            url = '/app/main/projects/' + calculation.projectId + '/pdccalcs/' + calculation.id;
        }
        else if (calculation.calculationType === 6) {
            url = '/app/main/projects/' + calculation.projectId + '/calcp/' + calculation.id;
        }
        else if (calculation.calculationType === 7) {
            url = '/app/main/projects/' + calculation.projectId + '/networkcalc/' + calculation.id;
        }
        else if (calculation.calculationType === 8) {
            url = '/app/main/projects/' + calculation.projectId + '/arcflash/' + calculation.id;
        }
        else if (calculation.calculationType === 9) {
            url = '/app/main/projects/' + calculation.projectId + '/iec-calcs/' + calculation.id;
        }
        else if (calculation.calculationType === 12) {
            url = '/app/main/projects/' + calculation.projectId + '/nec-calcs/' + calculation.id;
        }
        else if (calculation.calculationType === 13) {
            url = '/app/main/projects/' + calculation.projectId + '/nz-calcs/' + calculation.id;
        }
        else {
            return;
        }
        let fullUrl = url;
        if (this._router.url.split('?')[0] == encodeURI(fullUrl))
            result = true;
        return result;
    }

    checkProjectActiveClass(project): boolean {
        let result: boolean = false;
        var url = '/app/main/projects/' + project.id + '/calcs';

        let fullUrl = url;
        if (this._router.url.split('?')[0] == encodeURI(fullUrl))
            result = true;
        return result;
    }

    setExpirePlanDetails(): void {
        this.expiredPlanHeadingText = '';
        this.expiredPlanBodyText = '';
        this.SetExpiredPlanPopText();
        this.ShowExpiryPopUp();
    };

    SetExpiredPlanPopText(): void {
        this.expiredPlanHeadingText = this.premiumUser ? 'Your Plan has Expired' : 'Your Free Trial has Ended';
        this.expiredPlanBodyText = this.premiumUser ? 'We have great value monthly and annual plans' : 'Please purchase a plan';
    };

    ShowExpiryPopUp(): void {
        $('#ListSubscriptionExpiredModel').appendTo("body").modal({
            show: true,
            keyboard: false,
            backdrop: 'static'
        });
    };

    extendTrialPeriod() {
        this.isLoaderForExtendPlan = true;
        this._planService.extendTrialPeriod().subscribe(result => {
            if (result) {
                window.location.reload();
            }
            this.isLoaderForExtendPlan = false;
        }, () => {
            this.isLoaderForExtendPlan = false;
        });
    }

    GoToPricing(): void {
        this._router.navigate(['/app/main/', 'pricing']);
        $('#team-model').modal('hide');
    };

    SetUpgradeLink() {
        //        
        // if (this.isPlanAddedManually === true) {
        this._router.navigate(['/app/main/', 'pricing']);
        // }
        // else
        //     this.ManageSubscription(this.user, this.loaderService, this._subscriptionService);
    }
}
